import { Button, Fade, Paper, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from '@mui/system';
import WPAPI from 'wpapi';
import { Link as RouterLink } from 'react-router-dom';
import SearchButton from '../search/SearchButton';

const Menu = ({ toggleDrawer, setMenu, menu, searchClicked, setSearchClicked }) => {

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const location = useLocation();
    let [hovered, setHovered] = useState();
    let [active, setActive] = useState();

    //Fetch menu data
    const wp = new WPAPI({ endpoint: WP_API_Settings.endpoint }); //custom API in functions.php
    wp.menus = wp.registerRoute(
        'wp/v2',
        'menu-tree',
        {
            params: [
                'menu'
            ]
        }
    );

    useEffect(() => {
        wp.menus().menu("main-menu").then(function (menuData) {
            setMenu(menuData);
        }).catch(function (err) {
            setMenu(null);
        });
    }, [])

    return (
        <>
            {menu &&
                Object.values(menu).map((item, i) => {
                    
                    //console.log(item)
                    
                    let selected = (!item.slug && location.pathname == '/') ? true : item.slug ? location.pathname.includes(`/${item.slug}`) : false

                    if(!mobile && item.title==='Search'){
                        return(
                            <SearchButton
                                searchClicked={searchClicked}
                                onClick={() => {
                                    setSearchClicked(!searchClicked);
                                }}
                            />
                        )
                    }
                    
                    return(
                        <Fade in={true} timeout={500 * i}>
                            <Box
                                sx={{
                                    position: 'relative',
                                    padding : '0 10px',
                                }}
                            >
                                <Button
                                    component={RouterLink}
                                    to={item.url}
                                    onMouseEnter={e => {
                                        setHovered(null);
                                        setActive(null);
                                        setHovered(i);
                                        setActive(i);
                                    }}
                                    onMouseLeave={e => {
                                        // setHovered(null);
                                        // setActive(null);
                                    }}
                                    onClick={e => {
                                        setHovered(null);
                                        setActive(null);
                                        setTimeout(toggleDrawer, 200);
                                    }}
                                    sx={{
                                        m: {
                                            xs: '0.5rem 0',
                                            md: '0 0.5rem'
                                        },
                                        p: '0.5rem 1rem',
                                        borderRadius: 0,
                                        color: theme => !selected ? theme.typography.mainColor : theme.palette.secondary.main,
                                        backgroundColor: item.ID == 122 ? '#E9531C' : 'transparent',
                                        color: item.ID == 122 ? '#ffffff' : '#000000',
                                        borderRadius:'2rem', //item.ID == 122 ? '50px' : '0',
                                        fontSize:{
                                            xs:'1.2rem',
                                            md:'1rem'
                                        },
                                        fontWeight: '600',
                                        '&:hover': {
                                            color:'#fff',
                                            backgroundColor:'#0C5EAA'// item.ID == 122 ? '#0C5EAA' : 'transparent',
                                        },
                                        transform: item.ID == 122 ? 'unset' : searchClicked ? 'translate(-300px, 0)' : 'translate(0, 0)',
                                        opacity: item.ID == 122 ? '1' : searchClicked ? 0 : 1,
                                        transition: item.ID == 122 ? 'unset' : 'transform 0.6s ease-in-out, opacity 0.3s ease-in-out'
                                    }}
                                >

                                    {item.title}

                                </Button>

                                {item.children ?
                                    <Box
                                        sx={{
                                            display: mobile ? 'none' : active == i ? 'flex' : 'none',
                                            height: hovered == i ? 'auto' : '0',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            position: 'absolute',
                                            top: '50px',
                                            left: '50%',
                                            transform: 'translate(-50%, 0)',
                                            width: '200px',
                                            boxShadow: theme => theme.shadows[5],

                                        }}
                                        onMouseEnter={e => {
                                            setHovered(i);
                                            setActive(i);
                                        }}
                                        onMouseLeave={e => {
                                            setHovered(null);
                                            setActive(null);
                                        }}
                                    >
                                         {/* <Box
                                            sx={{
                                                borderLeft: '8px solid transparent',
                                                borderRight: '8px solid transparent',
                                                borderBottom: '16px solid white',
                                                zIndex: '9'
                                            }}
                                        /> */}
                                        <Paper
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                width: '100%',
                                                p: '20px 8px',                                                            
                                                zIndex: '10',
                                            }}
                                        >
                                            {Object.values(item.children).map((child) => {
                                                let childSelected = child.slug == location.pathname.substring(1) ? true : false;
                                                return (
                                                    <Button
                                                    component={RouterLink}
                                                    to={(child.url).replace(window.location.origin, '')}
                                                        sx={{
                                                            //height: '50px',
                                                            width: '100%',
                                                            borderRadius: 0,
                                                            padding: '8px',
                                                            borderBottom: theme => childSelected ? '2px solid ' + theme.palette.highlight : '2px solid transparent'
                                                        }}
                                                        onClick={e => {
                                                            // if (process.env.NODE_ENV === "production") {
                                                            //     navigate(child.url.replace(window.location.origin, ''))
                                                            //     //make the page jump to the top
                                                            // } else {
                                                            //     navigate(child.url.replace(window.location.origin, ''))
                                                            //     // navigate(`/${child.url}`)
                                                            //     //make the page jump to the top
                                                            // }
                                                            setHovered(null);
                                                            setActive(null);
                                                            setTimeout(toggleDrawer, 200);
                                                        }}
                                                    >
                                                        <Typography
                                                            variant='h4'
                                                            component='h4'
                                                            sx={{
                                                                width: '100%',
                                                                textAlign: 'center',
                                                                color: theme => theme.palette.greyDark
                                                            }}
                                                        >
                                                            {child.title}
                                                        </Typography>
                                                    </Button>
                                                )
                                            })}
                                        </Paper>
                                    </Box>
                                    : null}

                            </Box>
                        </Fade>
                    )
                }
                )}
        </>
    );
};

export default Menu;
